module.exports = __webpack_public_path__ + "img/3_154.fd568224.png";